import { LandService } from '../../api';
import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from './types';

export const getLaender = () => async (dispatch: Dispatch<ReduxAction>) => {
  new LandService().getLaender().then(response => {
    dispatch({
      type: ActionTypes.GET_LAENDER,
      payload: response.data,
    });
  });
};

export const searchLaender =
  (lkz: string) => async (dispatch: Dispatch<ReduxAction>) => {
    if (!lkz) return null;
    new LandService().searchLaender(lkz).then(response => {
      dispatch({
        type: ActionTypes.SEARCH_LAENDER,
        payload: response.data,
      });
    });
  };
